<script setup>
const props = defineProps({
  class: {
    type: String,
    default: ''
  }
})
</script>
<template>
<svg
  :class="props.class"
  width="12"
  height="13"
  viewBox="0 0 12 13"
  fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C3.51472 2 1.5 4.01472 1.5 6.5C1.5 8.98528 3.51472 11 6 11C8.48528 11 10.5 8.98528 10.5 6.5C10.5 4.01472 8.48528 2 6 2ZM0.5 6.5C0.5 3.46243 2.96243 1 6 1C9.03757 1 11.5 3.46243 11.5 6.5C11.5 9.53757 9.03757 12 6 12C2.96243 12 0.5 9.53757 0.5 6.5ZM6 3C6.27614 3 6.5 3.22386 6.5 3.5V6.19098L8.22361 7.05279C8.4706 7.17628 8.57071 7.47662 8.44721 7.72361C8.32372 7.9706 8.02338 8.07071 7.77639 7.94721L5.77639 6.94721C5.607 6.86252 5.5 6.68939 5.5 6.5V3.5C5.5 3.22386 5.72386 3 6 3Z" 
    fill="currentColor"/>
</svg>
</template>